export function openTermsAndConditionsPageInNewTab(): void {
    window.open('https://www.ambit.la/privacy', '_blank');
}
